import { Router } from '@angular/router';
import { AbstractControl, UntypedFormControl, FormControlName, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-askforfactor',
  templateUrl: './askforfactor.component.html',
  styleUrls: ['./askforfactor.component.css']
})
export class AskforfactorComponent implements OnInit, OnDestroy {
  zone: any;
  usercode: any;
  Formfactor: UntypedFormGroup;
  submitted = false;
  constructor(private spinner: NgxSpinnerService, private auth: Authenticationservice, private router: Router) {
    let userdata: any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.usercode = userdata.supcode;
    this.goloadfarmerinzone();
    this.goloadstock();

    this.Formfactor = new UntypedFormGroup({
      localstock: new UntypedFormControl('', Validators.required),
      cemecal: new UntypedFormControl('', Validators.required),
      countcemecal: new UntypedFormControl('', Validators.required),
      fertilizer: new UntypedFormControl('', Validators.required),
      countfertilizer: new UntypedFormControl('', Validators.required),
      dolomite: new UntypedFormControl('', Validators.required),
      countdolomite: new UntypedFormControl('', Validators.required),
      medical: new UntypedFormControl('', Validators.required),
      countmedical: new UntypedFormControl('', Validators.required),
      machine: new UntypedFormControl('', Validators.required),
      countmachine: new UntypedFormControl('', Validators.required),
      cash: new UntypedFormControl()


    });

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.goloaddolomite();
      this.goloadchemical();
      this.goloadmachine();
      this.goloadmedic();
      this.goloadorganic();
    }, 1500);
  }

  get factor(): { [key: string]: AbstractControl } {
    return this.Formfactor.controls;
  }


  // โหลดข้อมูล stock ปุ๋ย
  fertilizerstock: any;
  goloadstock() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_StockBRD")
      .then(res => {
        this.fertilizerstock = res.data.recordset;
      }).catch(err => { throw (err) })
  }
  // โหลดข้อมูลชาวไร่ในเขต
  famerlist: any;
  goloadfarmerinzone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?supzone=" + this.zone;
    axios.get(url)
      .then(res => {
        this.famerlist = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // โหลดข้อมูลชาวไร่ 1 คน
  dataonefarmer: any;
  ckfarmercan = false;
  goloaddata() {
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    if (fmcode == '') { }
    else {
      var ckfamer = this.famerlist.filter(el => el.fmcode_b1 == fmcode);
      if (ckfamer[0].PromiseIN == 0 || ckfamer[0].approve == 'N') {
        alert("ไม่สามารถเบิกได้ค่ะ");
        this.ckfarmercan = true;
      }
      else if (ckfamer[0].zoneban == 'Y') {
        alert("ไม่สามารถเบิกได้ค่ะ เนื่องจากเป็นโซนต้องห้าม");
        this.ckfarmercan = true;
      }

      else {
        this.ckfarmercan = false;
      }
      this.dataonefarmer = null;
      //  โหลดแปลงชาวไร่
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_cp6566_getFert12_w?fmcode=" + fmcode;
      axios.get(url)
        .then(res => {
          this.spinner.show();
          this.dataonefarmer = (res.data.recordset);
          this.dataonefarmer.sort((a: any, b: any) => (parseInt(a.intlandno.slice(0, 2)) > parseInt(b.intlandno.slice(0, 2))) ? 1 : -1);
          this.spinner.hide();
        }).catch(err => { console.log(err); })
      this.goloadfertiltzerbyfmcode(fmcode);
      this.Loadaskforfactorlist(fmcode);
    }
  }

  //  รายการด้านล่าง
  onecode: any;
  Loadaskforfactorlist(fmcode: any) {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfactor6566w?fmcode=%27" + fmcode + "%27")
      .then(res => {
        this.spinner.show();
        this.onecode = res.data.recordset;
        this.spinner.hide();
      }).catch(err => { console.log(err); })
  }

  //  โหลดข้อมูลปุ๋ยในแปลง
  ferplantdata: any;
  goloadfertiltzerbyfmcode(fmcode) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode='" + fmcode + "'";
    axios.get(url)
      .then(res => {
        this.ferplantdata = res.data.recordset;
      }).catch(err => { console.log(err); })
  }

  //  โหลด Dolomite
  dolomitedata: any;
  goloaddolomite() {
    this.spinner.show();
    // console.log(fmcode.slice(1,11));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_stock_w?group_type=4";
    axios.get(url)
      .then(res => {
        this.dolomitedata = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // โหลดยา
  medicdata: any;
  goloadmedic() {
    this.spinner.show();
    // console.log(fmcode.slice(1,11));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_get3";
    axios.get(url)
      .then(res => {
        this.medicdata = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // โหลดอุปกรณ์
  machinedata: any;
  goloadmachine() {
    this.spinner.show();
    // console.log(fmcode.slice(1,11));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_get5";
    axios.get(url)
      .then(res => {
        this.machinedata = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // โหลดปุ๋ยเคมี
  chemicaldata: any;
  goloadchemical() {
    this.spinner.show();
    // console.log(fmcode.slice(1,11));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_stock_w?group_type=1";
    axios.get(url)
      .then(res => {
        this.chemicaldata = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // โหลดปุ๋ยอินทรีย์
  organicdata: any;
  goloadorganic() {
    this.spinner.show();
    // console.log(fmcode.slice(1,11));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_stock_w?group_type=2";
    axios.get(url)
      .then(res => {
        this.organicdata = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }


  // เลือก 1 แปลง
  oneplant: any;
  famername: any;
  intlandno: any;
  Selectoneplant(itid) {
    this.oneplant = this.dataonefarmer.filter(el => el.itid === itid);
    console.log(this.oneplant);
    this.famername = this.oneplant[0].fmname;
    this.intlandno = this.oneplant[0].intlandno;
  }

  cangetcaneOrganic: any;
  ChangeValue(id: any) {
    this.cangetcaneOrganic = this.oneplant[0].balance_Organic;
    // let lastdata = this.oneplant[0].balance_Organic;
    if (id == 1) {
      let cemecal = this.Formfactor.get('cemecal').value;
      this.oneplant[0].caneGetfert12 = (this.oneplant[0].balance_fert12 * parseInt(cemecal[1]));
    }

    if (id == 2) {
      let fertilizer = this.Formfactor.get('fertilizer').value;
      this.cangetcaneOrganic = (this.oneplant[0].balance_Organic * parseInt(fertilizer[1]))
    }

  }

  //บันทึกข้อมูลเบิกปัจจัย
  Savedatafactor() {
    this.submitted = true;
    let localstock = this.Formfactor.get('localstock').value;
    let cemecal = this.Formfactor.get('cemecal').value;
    let countcemecal = this.Formfactor.get('countcemecal').value;
    let fertilizer = this.Formfactor.get('fertilizer').value;
    let countfertilizer = this.Formfactor.get('countfertilizer').value;
    let dolomite = this.Formfactor.get('dolomite').value;
    let countdolomite = this.Formfactor.get('countdolomite').value;
    let medical = (this.Formfactor.get('medical').value).slice(1, 10);
    let countmedical = this.Formfactor.get('countmedical').value;
    let machine = (this.Formfactor.get('machine').value).slice(1, 10);
    let countmachine = this.Formfactor.get('countmachine').value;
    let takecash = this.Formfactor.get('cash').value;
    let cash = 0;
    if (medical == '0000-0000') { medical = 0; }
    if (machine == '0000-0000') { machine = 0; }
    if (takecash == true) {
      cash = 1;
    }
    else {
      cash = 0;
    }

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='" + this.usercode + "'"
      + "&factor_type=2"
      + "&YearID='6566'"
      + "&doc_status=8"

      // แปลงชาวไร่
      + "&itid=%27" + this.oneplant[0].itid + "%27"
      + "&intlandno=%27" + this.intlandno + "%27"
      + "&fmcode=%27" + this.oneplant[0].fmcode + "%27"
      // แปลงชาวไร่

      + "&stockid=%27" + localstock.trim() + "%27"
      + "&get1=%27" + cemecal[0] + "%27"
      + "&get2=%27" + fertilizer[0] + "%27"
      + "&get3=%27" + medical + "%27"
      + "&get4=%27" + dolomite[0] + "%27"
      + "&get5=%27" + machine + "%27"
      + "&amt1=" + ((countcemecal))
      + "&amt2=" + ((countfertilizer))
      + "&amt3=" + ((countmedical))
      + "&amt4=" + ((countdolomite))
      + "&amt5=" + countmachine
      + "&take_method=" + cash;
    if (this.oneplant == undefined || this.oneplant == null) {
      alert("เลือกแปลง");
    }
    else if (this.intlandno == undefined || this.intlandno == '' || this.intlandno == null) {
      alert("เลือกแปลง");
    }
    else if (localstock == undefined || localstock == '' || localstock == null) {
      alert("เลือกรายการสต็อค");
    }
    else if (cash != 1) {
      if ((countcemecal) > (this.oneplant[0].balance_fert12 * parseInt(cemecal[1]))) {
        alert("ไม่สามารถเบิกปุ๋ยเคมีได้เนื่องจากเกินจำนวน");
      }
      /*else if ((countdolomite) > (this.oneplant[0].balance_Dolomite * parseInt(dolomite[1]))) {
        alert("ไม่สามารถเบิก โดโลไมท์ ได้เนื่องจากเกินจำนวน");
        console.log((countdolomite));
      }*/
      else if ((countfertilizer) > (this.oneplant[0].balance_Organic * parseInt(fertilizer[1]))) {
        alert("ไม่สามารถเบิก ปุ๋ยอินทรีย์ ได้เนื่องจากเกินจำนวน");
        console.log(this.oneplant[0].balance_Organic * parseInt(fertilizer[1]));
        console.log((countfertilizer));
      }
      else {
        console.log(url);
        this.SendRequese(url);
      }
    }

    else {
      console.log(url);
      this.SendRequese(url);
    }

  }
  //สงบันทึกข้อมูลเบิกปัจจัย
  SendRequese(url: any) {
    axios.post(url)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ ^^");
          this.cleardata();

          this.Loadaskforfactorlist(this.oneplant[0].fmcode);
          this.oneplant = null;
        }
        else if (res.data.code) {
          alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
        }
        else {
          alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
        }
      }).catch(err => { throw (err) })
  }

  //  clear input
  cleardata() {
    $("input[type=number]").val('');
    this.Formfactor.reset();
    this.Formfactor.get("localstock").setValue('0');
    this.Formfactor.get("cemecal").setValue('0');
    this.Formfactor.get("fertilizer").setValue('0');
    this.Formfactor.get("dolomite").setValue('0');
    this.Formfactor.get("medical").setValue('0');
    this.Formfactor.get("machine").setValue('0');
    this.oneplant = null;
    this.famername = null;
    this.intlandno = null;
  }

  cancledata(docid: any) {

    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + docid + "&doc_status=X";
    if (confirm('ต้องยกเลิกรายการนี้ ' + docid + ' ใช่หรือไม่') == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("ยกเลิกเรียบร้อยแล้วค่ะ ^^");
            this.Loadaskforfactorlist(fmcode);
          }
          else if (res.data.code) {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
          else {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
        }).catch(err => { throw (err) })
      this.goloaddata();

    }
    else { }


  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.organicdata = null;
    this.chemicaldata = null;
    this.dolomitedata = null;
    this.fertilizerstock = null;
    this.machinedata = null;
    this.medicdata = null;
    this.famerlist = null;
    this.dataonefarmer = null;
  }

  //year :string='6566'
  // ออกใบพิมพ์
  printdoc(year,fmcode, docid) {
    this.router.navigateByUrl("/docfertilizer", { state: {year:year, data: fmcode, doc_id: docid } });
  }
}
